import http from "./http";

export type ServiceInterestType = "esim" | "airport";

export type AdminServiceInterestRecord = {
	id: number;
	orderId: number;
	customerUserId?: number | null;
	serviceType: "esim" | "airport" | string;
	customerName?: string | null;
	customerEmail?: string | null;
	customerPhone?: string | null;
	customerPhonePrefix?: string | null;
	clickCount: number;
	clickedAt: string;
	createdAt: string;
	updatedAt: string;
	order?: {
		id: number;
		quantity?: number | null;
		totalMoney?: number | null;
		timeIn?: string | null;
		timeOut?: string | null;
		timeInString?: string | null;
		timeOutString?: string | null;
		partner?: {
			id: number;
			name?: string | null;
			displayName?: string | null;
			address?: string | null;
			displayAddress?: string | null;
		} | null;
		customer?: {
			id: number;
			fullName?: string | null;
			email?: string | null;
			phone?: string | null;
			phonePrefix?: string | null;
		} | null;
	} | null;
};

export type AdminServiceInterestSummary = {
	serviceType: "esim" | "airport" | string;
	totalRequests: number;
};

export type AdminServiceInterestAnalytics = {
	totalUniqueRequests: number;
	uniqueBookings: number;
	byService: Array<{
		serviceType: "esim" | "airport" | string;
		totalRequests: number;
		share: number;
	}>;
	byStation: Array<{
		stationName: string;
		stationAddress?: string | null;
		totalRequests: number;
		share: number;
	}>;
	dailyTrend: Array<{
		date: string;
		totalRequests: number;
		esimRequests: number;
		airportRequests: number;
	}>;
	recentIntents: Array<{
		id: number;
		orderId: number;
		serviceType: "esim" | "airport" | string;
		clickedAt: string;
		customerName?: string | null;
		stationName?: string | null;
	}>;
};

export async function trackServiceInterest(orderId: string, serviceType: ServiceInterestType, code?: string | null) {
	const payload = {
		orderId,
		serviceType,
		...(code ? { code } : {}),
	};

	const { data } = await http.post("/service-interest-click", payload);
	return data;
}

export async function getAdminServiceInterestClicks(params: { page?: number; perPage?: number } = {}): Promise<{
	docs: AdminServiceInterestRecord[];
	total: number;
	page: number;
	perPage: number;
	summary: AdminServiceInterestSummary[];
	analytics: AdminServiceInterestAnalytics;
}> {
	const { data } = await http.get("/admin/service-interest-clicks", { params });
	return {
		docs: (data?.docs || []) as AdminServiceInterestRecord[],
		total: data?.total || 0,
		page: data?.page || 1,
		perPage: data?.perPage || params.perPage || 20,
		summary: (data?.summary || []) as AdminServiceInterestSummary[],
		analytics: (data?.analytics || {
			totalUniqueRequests: 0,
			uniqueBookings: 0,
			byService: [],
			byStation: [],
			dailyTrend: [],
			recentIntents: [],
		}) as AdminServiceInterestAnalytics,
	};
}
